import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { CodeTypesController } from '../../models/master/mastermodel';


@Pipe({
  name: 'CodeTypeFilter'
})

@Injectable()
export class CodeTypePipe implements PipeTransform {

  transform(value: CodeTypesController[], filter: string): CodeTypesController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: CodeTypesController) =>
      app.Name != null && app.Name.toLocaleLowerCase().indexOf(filter) != -1

      || app.ShortName != null && app.ShortName.toLocaleLowerCase().indexOf(filter) != -1
      
    ) : value;
  }

}
